module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'djeg5w85',
    dataset: process.env.GATSBY_SANITY_DATASET || 'production'
  }
}
